import ApiService from "../ApiService";
import {Component} from "react";
import React from "react";
import {CommandBarButton, TextField} from "office-ui-fabric-react";
import {MessageBarButton} from "office-ui-fabric-react/lib-commonjs";
import {Link} from "react-router-dom";
import {IMessageBarHelper} from "../../utils/IMessageBarHelper";

interface StartOrchestrationCardProps
{
    apiService: ApiService;
    selectedApp: "mailroom";
    messageBar: IMessageBarHelper;
}

interface StartOrchestrationCardState
{
    orchestrationName: string
}

export default class StartOrchestrationCard extends Component<StartOrchestrationCardProps,StartOrchestrationCardState>
{

    constructor(props: Readonly<StartOrchestrationCardProps>) {
        super(props);
        
        this.state = {
            orchestrationName: ""
        }
    }
    
    start = async () =>
    {
        try
        {
            const result = await this.props.apiService.mailroomStartOrchestration(this.state.orchestrationName);

            const goToButton = (
                <Link to={`/cdb-admin/durable-functions/instances/${result.instanceId}`} target={"_blank"}>
                    <MessageBarButton
                        onClick={async () => {
                        }}>
                        Open
                    </MessageBarButton>
                </Link>
            )
            this.props.messageBar.success(`Started ${this.state.orchestrationName} with id : ${result.instanceId}`,goToButton)
        }
        catch (e)
        {
            this.props.messageBar.error(`Failed to start ${this.state.orchestrationName} (${this.props.selectedApp})`,undefined);
        }
        
    }
    
    render() {
        return (
            <div className="card">
                <div className="card__header">
                    <span className={"card__title"}>Start Orchestration ({this.props.selectedApp})</span>
                    <CommandBarButton
                        iconProps={{iconName: "Rocket"}}
                        disabled={this.state.orchestrationName === ""}
                        text={"Start"}
                        onClick={this.start}
                    />
                </div>
                <div className="card__content">
                    
                    <TextField
                        label={"Name"}
                        value={this.state.orchestrationName}
                        onChange={(e,v) => {
                            this.setState({
                                orchestrationName: v as string
                            });
                        }}/>
                </div>
            </div>
        );
    }
}